module.exports = __webpack_public_path__ + "img/logo-portugal-2020-branco.0946594f.png";